import { useMutation, type UseMutationOptions } from '@tanstack/react-query'
import { commonService } from '../services/common/common.service'

import type {
    GenericDatabasePayload,
    TestConnectionResponse
} from '../services/common/common.types'

export const useTestConnectionMutation = (
    options?: UseMutationOptions<
        TestConnectionResponse,
        Error,
        GenericDatabasePayload
    >
) => {
    return useMutation<
        TestConnectionResponse,
        Error,
        GenericDatabasePayload
    >({
        mutationFn: commonService.testConnection,
        ...options,
    })
}